import { fetchEvents } from 'api';
import { GET_EVENTS } from './types';
import { updateSource, clearSelection } from '../map/actions';

export const getEvents = () => dispatch =>
  dispatch({
    type: GET_EVENTS,
    promise: fetchEvents(),
    meta: {
      onSuccess: () => {
        dispatch(clearSelection());
        dispatch(updateSource());
      },
    },
  });
